import type { BlockDef } from '../../prop-types.ts'
import { EMPTY_TEXT } from '../../text.ts'

/** The call-to-action band. `fullOnly` — a CTA at a third width beside a paragraph is a button
 *  nobody presses, and the width control was where that got discovered. */
export const cta: BlockDef = {
  type: 'cta',
  v: 1,
  label: { en: 'Call to action', ar: 'دعوة لاتخاذ إجراء' },
  scope: 'page',
  fullOnly: true,
  description: 'A full-width band with one sentence and one button. The moment the page asks for something.',
  whenToUse: 'Once, near the bottom of a page, or between two long sections — "Book a table", "Get a quote", "Call us".',
  whenNotToUse: 'Repeatedly down one page. Two CTAs competing on one screen halve each other; if there are two actions, one of them belongs in the navigation.',
  variants: [
    { value: 'band', label: { en: 'Band', ar: 'شريط' } },
    { value: 'boxed', label: { en: 'In a box', ar: 'داخل إطار' } },
  ],
  fields: [
    { key: 'heading', label: { en: 'Headline', ar: 'العنوان' }, type: { kind: 'text' }, default: EMPTY_TEXT, requiredForPublish: true },
    { key: 'subheading', label: { en: 'Supporting line', ar: 'سطر داعم' }, type: { kind: 'text' }, default: EMPTY_TEXT },
    { key: 'ctaLabel', label: { en: 'Button text', ar: 'نص الزر' }, type: { kind: 'text' }, default: EMPTY_TEXT, requiredForPublish: true, alongside: 'ctaLink' },
    { key: 'ctaLink', label: { en: 'Button goes to', ar: 'الزر ينتقل إلى' }, type: { kind: 'link' }, default: { kind: 'none' }, requiredForPublish: true },
    { key: 'background', label: { en: 'Background', ar: 'الخلفية' }, type: { kind: 'colorToken' }, scope: 'tmpl', default: 'brand' },
  ],
}
